'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getLang2 = require('I18n/utils/getLang');

var _getLang3 = _interopRequireDefault(_getLang2);

var _userInfo = require('hub-http/userInfo');

var _userInfo2 = _interopRequireDefault(_userInfo);

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _usageTrackerCore = require('usage-tracker-core');

var _storageKeys = require('usage-tracker-core/storageKeys');

var _cookieHelper = require('./helpers/cookieHelper');

var cookieHelper = _interopRequireWildcard(_cookieHelper);

var _sendBeacon = require('./helpers/sendBeacon');

var _sendBeacon2 = _interopRequireDefault(_sendBeacon);

var _reportError = require('./helpers/reportError');

var _reportError2 = _interopRequireDefault(_reportError);

var _tempStorage = require('./containers/tempStorage');

var tempStorage = _interopRequireWildcard(_tempStorage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasBeaconSupport = navigator && typeof navigator.sendBeacon === 'function';
var suffix = _enviro2.default.getShort() === 'qa' ? 'qa' : '';
var origin = 'https://app.hubspot' + suffix + '.com';
var path = '/usage-logging/v1/log/hublytics-multi/no-auth';
var reportNetworkError = function reportNetworkError(err) {
  return (0, _reportError2.default)(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};

var trackingClient = (0, _usageTrackerCore.createClient)({
  getDebug: function getDebug() {
    return _enviro2.default.debug(_storageKeys.debugKey);
  },
  getEmail: function getEmail() {
    return (0, _userInfo2.default)().then(function (_ref) {
      var user = _ref.user;
      return user.email;
    });
  },
  getHubId: function getHubId() {
    return (0, _userInfo2.default)().then(function (_ref2) {
      var portal = _ref2.portal;
      return portal.portal_id;
    });
  },
  getHstc: function getHstc() {
    return cookieHelper.get(_storageKeys.hstcKey) || '';
  },
  getLang: function getLang() {
    return _I18n2.default.Info.then(_getLang3.default);
  },
  getTempStorage: tempStorage.get,
  setTempStorage: tempStorage.set,
  reportError: _reportError2.default,
  send: function send(_ref3) {
    var events = _ref3.events,
        query = _ref3.query,
        isAuthed = _ref3.isAuthed,
        isBeforeUnload = _ref3.isBeforeUnload;

    var endpoint = path + '?' + query;
    var data = events;
    var sendXhr = function sendXhr() {
      var promise = void 0;

      if (isAuthed) {
        promise = _apiClient2.default.post(endpoint, { data: data }).catch(reportNetworkError);
      } else {
        promise = _noAuthApiClient2.default.post(endpoint, { data: data }).catch(reportNetworkError);
      }

      if (promise && typeof promise.done === 'function') {
        promise.done();
      }
    };

    if (isBeforeUnload && hasBeaconSupport) {
      (0, _sendBeacon2.default)('' + origin + endpoint, data, sendXhr);
    } else {
      sendXhr();
    }
  }
});

exports.default = trackingClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker/static-1.85/js/client.js
// module id = 376
// module chunks = 0